import React from 'react';
import { BrowserQRCodeSvgWriter } from '@zxing/library';
import {
  ParsedScannedOrders,
  ProgressScanningTodaySummary,
} from '../ProgressScanningTodaySummary/ProgressScanningTodaySummary';
import { parseScannedOrders } from '../ProgressScanningTodaySummary/ProgressScanningTodaySummary';
import './HubTableBar.scss';
import { COLOR } from 'const/color';
import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';
import dayjs from 'dayjs';

function showShelfIdColor(parseScannedOrdersResult: ParsedScannedOrders) {
  if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress === 0 &&
    parseScannedOrdersResult.completed > 0
  ) {
    return COLOR.PROGRESS_GREEN;
  } else if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress > 0 &&
    parseScannedOrdersResult.completed >= 0
  ) {
    return COLOR.PROGRESS_YELLOW;
  } else if (parseScannedOrdersResult.remaining > 0) {
    return COLOR.PROGRESS_RED;
  } else if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress === 0 &&
    parseScannedOrdersResult.completed === 0
  ) {
    return COLOR.PROGRESS_BLACK;
  } else {
    return COLOR.PROGRESS_PURPLE;
  }
}

export const HubTableBar = ({
  shelfId = '',
  bundleId = '',
  scannedOrders = [] as HubSortListOrderEntry[],
  courierName = '',
}: HubTableBarProps): JSX.Element => {
  const todayDay = dayjs().format('YYYY-MM-DD');
  const parseScannedOrdersResult = parseScannedOrders(scannedOrders);

  const codeWriter = new BrowserQRCodeSvgWriter();
  const QRCodeSvgShelfId = shelfId ? codeWriter.write(shelfId, 200, 200) : null;

  return (
    <div className="u-pbl">
      <div className="HubTableBar">
        <div className="TopInfo  u-print-only">
          <div className="QrSymbol">
            <div style={{ height: '10px' }} />
            {QRCodeSvgShelfId && (
              <div
                dangerouslySetInnerHTML={{ __html: QRCodeSvgShelfId.outerHTML }}
              />
            )}
          </div>
          <div className="HubTableBar-shelfId-big">
            <div className="shelfIdTextBig">{shelfId}</div>
          </div>
        </div>

        <div className="HubTableBar-topBar">
          <div
            className="HubTableBar-shelfId"
            style={{
              backgroundColor: showShelfIdColor(parseScannedOrdersResult),
            }}
          >
            <div className="shelfIdText">{shelfId}</div>
          </div>

          <div className="hub-ok-or-complete u-print-only">
            <div className="hub-text">INCOMPLETE</div>
            <div className="hub-text-invisible"> {'________'} </div>
            <div className="hub-text"> OK </div>
          </div>
          <div className="hub-digital-progressBar u-screen-only">
            <ProgressScanningTodaySummary
              scannedOrders={parseScannedOrdersResult}
            />
          </div>
          <div className="HubTableBar-time-and-bundle">
            <div className="dateText u-print-only">{todayDay}</div>
            <div className="bundleIdText">{bundleId}</div>
          </div>
        </div>
        <div className="Driver-text u-print-only">DRIVER: </div>
        <div className="Driver-text u-screen-only u-hidden-mobile">
          DRIVER: {courierName ? courierName : '...'}
        </div>
      </div>
    </div>
  );
};

interface HubTableBarProps {
  shelfId?: string;
  bundleId?: string;
  scannedOrders?: HubSortListOrderEntry[];
  courierName?: string;
}
